import { html } from "lit";
import { styles } from "./styles";
import { myProjectsList } from "../../data/projects";
import { translate } from "lit-translate";
import { BasicApp } from "../../layout/basicApp";

class ProjectsTab extends BasicApp {
  constructor() {
    super();
  }
  createRenderRoot() {
    return this;
  }

  static get styles() {
    return [styles]
  }

  render() {
    const projectCards = myProjectsList.map(project => {
      const prevProjectId = project.id > 0 ? (project.id - 1) : null
      const nextProjectId = project.id < myProjectsList.length ? (project.id + 1) : null

      return html`<li data-technology="${project.main_technology}" class="project-box">
          <a href="#modal-${project.id}" uk-toggle>
<!--              Card-->
              <div class="uk-card uk-card-default">
                <div class="uk-card-media-top">
                    <div class="uk-height-medium uk-flex uk-flex-center uk-flex-middle uk-background-cover uk-light"
                         data-src="${project.img_src}"
                        data-srcset="${project.img_src}"
                        data-sizes="(min-width: 650px) 650px, 100vw" uk-img>
                        ${project.legacy ? (
                                html`
                                    <div class="uk-position-absolute uk-position-top-right uk-text-white legacy">
                                        Legacy
                                    </div>
                                `
                        ) : ''}
                    </div>
                </div>
                  <div class="uk-card-body">
                      <h3 class="uk-card-title">${translate(project.title)}</h3>
                </div>
            </div> 
          </a>
          
          <!-- Card modal with details -->
          <div id="modal-${project.id}" uk-modal>
              <div class="uk-modal-dialog uk-modal-body">
                  <button class="uk-modal-close-default" type="button" uk-close></button>
                  <h2 class="uk-modal-title">${translate(project.title)}</h2>
                  <p class="uk-text-right">
                      ${project.technologies.map(technology =>
                              { return html`<span class="uk-badge project-tag">${technology}</span>`}
                      )}
                      ${project.legacy ? (
                              html`
                                    <span class="uk-badge project-tag legacy" style="background-color: #ed2939 !important;">
                                        Legacy
                                    </span>
                                `
                      ) : ''}
                  </p>
                  <div class="uk-height-medium uk-flex uk-flex-center uk-flex-middle uk-background-cover uk-light"
                       data-src="${project.img_src}"
                       data-srcset="${project.img_src}"
                       data-sizes="(min-width: 650px) 650px, 100vw" uk-img>
                  </div>
                  ${project.linkDemo || project.linkCode ? html`
                  <p class="uk-text-left buttons">
                      ${project.linkDemo ? html`<a href="${project.linkDemo}" target="_blank" class="uk-button uk-button-default btn ">${translate("projects.links.liveDemo")}</a>` : ''}
                      ${project.linkCode ? html`<a href="${project.linkCode}" target="_blank" class="uk-button uk-button-default btn btn--outlined">${translate("projects.links.code")}</a>` : ''}
                  </p>` : ''}
                  <p>${translate(project.description)}</p>
                  ${ project.frontendMentorLink ? html`<p>${translate("projects.links.frontendMentor")} <a href="${project.frontendMentorLink}" target="_blank">${project.frontendMentorLinkTitle}</a></p>` : html``}
                  
                  <p class="uk-text-right">
                      <a class="uk-button uk-button-default ${prevProjectId ? '' : 'hidden'}" href="#modal-${prevProjectId}" uk-toggle>Prev project</a>
                      <a class="uk-button uk-button-default ${nextProjectId ? '' : 'hidden'}" href="#modal-${nextProjectId}" uk-toggle>Next project</a>
                  </p>
              </div>
          </div>
      </li>`
    });

    return html`
        <div class="outer">
            <h1 class="page-ttl">${translate("projects.title")}</h1>
            <div uk-filter="target: .js-filter">
                <ul class="uk-subnav uk-subnav-pill">
                    <li class="uk-active" uk-filter-control><a href="#">${translate("projects.filters.All")}</a></li>
                    <li uk-filter-control="[data-technology*='html']"><a href="#">HTML</a></li>
                    <li uk-filter-control="[data-technology*='react']"><a href="#">React</a></li>
                    <li uk-filter-control="[data-technology*='vue']"><a href="#">Vue</a></li>
                    <li uk-filter-control="[data-technology*='next']"><a href="#">Next.js</a></li>
                </ul>
                <ul class="js-filter uk-child-width-1-2 uk-child-width-1-3@m uk-text-center projects-wr" uk-grid="match: true">
                    ${projectCards}
                </ul>
            </div>
        </div>
    `;
  }
}

customElements.define('projects-tab', ProjectsTab);
